export const DATE_FORMAT = 'd MMM'

export const IMMEDIATE_DISABLED_REASON =
  'This schedule starts in the future, so changes cannot take effect immediately'
export const SCHEDULE_ENDS_FIRST_REASON =
  'This schedule ends before the next billing period starts'
export const NEXT_BILLING_DATE_UNKNOWN_REASON =
  'Could not calculate next billing date'
